import type { HullPaintsDashboardResponse, HullPaintsVessel } from "../models/hull-paints.models";

const vessel = (
  vesselName: string,
  imoNumber: string,
  desk: string,
  built: string,
  yard: string,
  design: string,
  lastRequest: string,
  infoLogged: string | null,
  contractType: string,
  deliveryDate: string,
  redeliveryDate: string,
): HullPaintsVessel => ({
  vesselName,
  imoNumber,
  email: `${vesselName.toLowerCase().replaceAll(" ", ".")}@vessel.example`,
  desk,
  built,
  yard,
  design,
  lastRequest,
  infoLogged,
  contractType,
  deliveryDate,
  redeliveryDate,
});

// Mirrors the report fields with typed values so mock mode exercises the same filters and tables as the API.
export const HULL_PAINTS_MOCK_RESPONSE: HullPaintsDashboardResponse = {
  lastRefresh: "2026-08-03T07:06:18.000Z",
  vessels: [
    vessel("SEA JUNO", "9460588", "PANAMAX", "2011-07-01", "Oshima Shipbuilding Co Ltd", "Oshima 76D", "2026-08-03", null, "Period TC", "2019-05-01", "2027-03-30"),
    vessel("KRENOM", "9718014", "PANAMAX", "2016-04-01", "Jiangsu Jinling Ships Co Ltd", "SDARI KMAX 82", "2026-07-21", null, "Period TC", "2016-04-21", "2027-02-14"),
    vessel("SHANDONG DE LONG", "9872066", "CAPE", "2020-09-01", "Shanghai Waigaoqiao Shbldg", "SWS-180BC", "2026-06-18", "2026-07-02", "Period TC", "2026-06-08", "2031-05-24"),
    vessel("CAPRICORN CONFIDENCE", "9878369", "SUPRAMAX", "2020-07-01", "New Dayang Shipbuilding", "Crown 63", "2026-06-11", "2026-07-02", "Period TC", "2026-04-11", "2027-07-24"),
    vessel("CAPELLA", "9518165", "PANAMAX", "2013-07-01", "Tsuneishi Shbldg - Fukym", "Kamsarmax", "2026-06-05", null, "Trip TC", "2026-05-12", "2026-08-14"),
    vessel("ROYAL RESPECT", "9974010", "PANAMAX", "2024-05-01", "Tsuneishi Heavy Inds Cebu", "Kamsarmax New", "2026-06-05", null, "Period TC", "2024-05-13", "2029-03-13"),
    vessel("CASTLE POINT", "1042897", "SUPRAMAX", "2025-09-01", "Jiangsu Hantong WING HI", "DOLPHIN 64 NEW", "2026-02-11", null, "Period TC", "2025-07-03", "2026-09-18"),
    vessel("ADALINE", "9701243", "HANDY", "2015-09-01", "Namura Shipbuilding - Imari", "High Bulk 34E", "2025-12-04", null, "Period TC", "2024-08-12", "2027-09-30"),
  ],
  paints: [
    {
      imoNumber: "9460588",
      vesselName: "SEA JUNO",
      desk: "PANAMAX",
      dateOfApplication: "2024-03-18",
      manufacture: "Jotun",
      bootTop: "SeaQuantum Classic",
      verticalBottom: "SeaQuantum X200",
      flatBottom: "SeaForce 60M",
      attachmentName: "SEA_JUNO_paint_spec.pdf",
      attachmentLink: "https://example.invalid/sea-juno",
    },
    {
      imoNumber: "9872066",
      vesselName: "SHANDONG DE LONG",
      desk: "CAPE",
      dateOfApplication: "2025-11-02",
      manufacture: "International",
      bootTop: "Intersleek 1100SR",
      verticalBottom: "Intersmooth 7460HS",
      flatBottom: "Intershield 300",
      attachmentName: "SHANDONG_DE_LONG.xlsx",
      attachmentLink: "https://example.invalid/shandong-de-long",
    },
    {
      imoNumber: "9878369",
      vesselName: "CAPRICORN CONFIDENCE",
      desk: "SUPRAMAX",
      dateOfApplication: "2023-06-14",
      manufacture: "Hempel",
      bootTop: "Hempaguard X7",
      verticalBottom: "Hempaguard X8",
      flatBottom: "Hempadur Quattro",
      attachmentName: null,
      attachmentLink: null,
    },
  ],
};
